import { DatePicker } from "@mui/x-date-pickers";
import { LocalizationProvider } from "@mui/x-date-pickers/LocalizationProvider";
import { AdapterDateFns } from '@mui/x-date-pickers/AdapterDateFns';
import { TextField } from "@mui/material";
import { useEffect, useState } from "react";
import { useTranslation } from "react-i18next";

export default function Filter(
    props: FilterPropsTypes
) {
    const { t } = useTranslation();
    const [filter, setFilter] = useState<string>('');

    return (
        <div className="react-confirm-alert-body">
            <h1>{t("pages.partners.text.filterOfPartners")}</h1>
            <br />
            <TextField value={filter} onChange={(e) => setFilter(e.target.value)} fullWidth id="standard-basic" variant="standard" />

            <br />
            <small><b>*</b>{t("pages.partners.text.filterOptions")}</small>
            <div className="react-confirm-alert-button-group">
                <button onClick={() => props.onClickYes(filter)}>{t("common.apply")}</button>
                <button onClick={props.onClose}>{t("common.cancel")}</button>
            </div>
        </div>
    );
}

interface FilterPropsTypes {
    onClose: any;
    onClickYes: any;
}
